import { BroadcastIcon, NeighborIcon, PersonIcon } from '../../model/icons';

// Тип получателя рассылки (совпадает с RecipientType бэкенда).
export const RECIPIENT_TYPES = Object.freeze({
    SMENA: 'SMENA',
    TEAM: 'TEAM',
    STUDENT: 'STUDENT'
});

// Сегментированный выбор получателя.
export const RECIPIENT_OPTIONS = Object.freeze([
    { type: RECIPIENT_TYPES.SMENA, label: 'Всей смене', Icon: BroadcastIcon, showCount: true },
    { type: RECIPIENT_TYPES.TEAM, label: 'Команде', Icon: NeighborIcon },
    { type: RECIPIENT_TYPES.STUDENT, label: 'Студенту', Icon: PersonIcon }
]);
